let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aueHw")).then(() => parcelRequire('Qdom1'));